module.exports = __webpack_public_path__ + "img/kankou_8.84a9f138.jpg";